'use client'
import Icon from '@/components/ui/icons/Icon';
import { getActiveLocale } from '@/utils/active-locale';
import Link from 'next/link';
import React from 'react';

interface ArrowButtonProps {
  label: string;
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({ label }) => {
  const activeLocale = getActiveLocale();
  return (
    <Link href={`/${activeLocale}/over-ons`} className='group font-fractul flex absolute right-6 gap-3 items-center bottom-[35px] max-md:justify-center max-md:mt-8'>
      <span  className='text-base text-white group-hover:text-brand-50'>
        {label}
      </span>
      <button className='flex justify-center items-center w-8 h-8 bg-white rounded-full group-hover:bg-brand-50 transition-colors' aria-label='Navigate to About section'>
        <Icon name='arrow-right' className='transform duration-300 group-hover:translate-x-[1px]' />
      </button>
    </Link>
  );
};
